import { Pipe, PipeTransform } from '@angular/core';

export const AI_ASSISTANT_ICON_FILE_MAP: Record<string, string> = {
  'ai-chat-receptionist': 'chat-receptionist',
  'ai-voice-receptionist': 'voice-receptionist',
  'ai-sales-coach': 'sales-coach',
  'vendasta-ai': 'vendasta-ai',
  WebchatWidget: 'webchat',
  SMS: 'sms',
  Voice: 'voice',
  Whatsapp: 'whatsapp',
  GoogleMeet: 'google-meet',
};

export function aiAssistantAssetUrl(iconName: string | null | undefined, document: Document): string | null {
  if (!iconName) return null;
  const file = AI_ASSISTANT_ICON_FILE_MAP[iconName];
  if (!file) return null;
  const base =
    document.location.hostname === 'localhost'
      ? '/assets/ai-assistant/avatars'
      : `https://cdn.apigateway.co/${(globalThis as any)['appId']}/assets/ai-assistant/avatars`;
  return `${base}/${file}.svg`;
}

@Pipe({ name: 'aiAssistantAssetUrl'})
export class AiAssistantAssetUrlPipe implements PipeTransform {
  transform(iconName: string | null | undefined): string | null {
    if (!iconName) return null;
    const file = AI_ASSISTANT_ICON_FILE_MAP[iconName];
    if (!file) return null;
    return `ai-assistant/avatars/${file}.svg`;
  }
}
